import React, { useContext, useEffect, useState } from "react";
import { Context } from "../../context";
import classes from "./CookieBanner.module.css";

const COOKIE_NAME = "db_cookie_consent_v2";

const CookieBanner = () => {
  const { lang } = useContext(Context);
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Check if consent has already been given
    const hasConsent = document.cookie
      .split("; ")
      .some((row) => row.startsWith(`${COOKIE_NAME}=`));

    if (!hasConsent) {
      // Short delay for smooth appearance after page load
      const timer = setTimeout(() => setShow(true), 600);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    // Set cookie for 150 days (SameSite=Lax, path=/)
    const maxAge = 150 * 24 * 60 * 60;
    document.cookie = `${COOKIE_NAME}=true; max-age=${maxAge}; path=/; SameSite=Lax`;
    setShow(false);
  };

  const handleDecline = () => {
    // Technical cookies only
    const maxAge = 150 * 24 * 60 * 60;
    document.cookie = `${COOKIE_NAME}=essential; max-age=${maxAge}; path=/; SameSite=Lax`;
    setShow(false);
  };

  if (!show) return null;

  return (
    <aside
      className={classes.cookieBannerWrapper}
      role="dialog"
      aria-live="polite"
      aria-label="Informativa Cookie"
    >
      <div className={classes.cookieContent}>
        <div className={classes.cookieIconBadge}>
          🍪
        </div>
        <div className={classes.cookieTextWrapper}>
          <div className={classes.cookieTitle}>
            {lang === "it" ? "Cookie & Privacy Policy" : "Cookie & Privacy Policy"}
          </div>
          <p className={classes.cookieText}>
            {lang === "it" ? (
              <>
                Questo sito utilizza cookie tecnici per offrirti un'esperienza di navigazione ottimale e non raccoglie cookie di profilazione o tracciamento pubblicitario.
                <a href="/cookie" className={classes.cookiePolicyLink}>
                  Maggiori info
                </a>
              </>
            ) : (
              <>
                This website uses technical cookies to ensure the best browsing experience and does not collect tracking or profiling cookies.
                <a href="/cookie" className={classes.cookiePolicyLink}>
                  Learn more
                </a>
              </>
            )}
          </p>
        </div>
      </div>

      <div className={classes.cookieActions}>
        <button
          type="button"
          onClick={handleDecline}
          className={classes.declineBtn}
        >
          {lang === "it" ? "Solo necessari" : "Necessary only"}
        </button>
        <button
          type="button"
          onClick={handleAccept}
          className={classes.acceptBtn}
        >
          {lang === "it" ? "Accetta tutti" : "Accept all"}
        </button>
      </div>
    </aside>
  );
};

export default CookieBanner;
